import { combineReducers } from '@reduxjs/toolkit';
import { templateReducer } from '../modules/admin/template.slice';
import { appReducer } from '../modules/application';
import { authReducer } from '../modules/login/auth.slice';
import { moduleManagementReducer } from '../modules/module-management/modules/modules.slice';
import { prioritizationReducer } from '../modules/module-registrations/prioritization.slice';
import { registrationExportModule } from '../modules/module-registrations/registration-export.slice';
import { summaryModule } from '../modules/module-registrations/summary.slice';
import { uasRegistrationsModule } from '../modules/module-registrations/uas-registrations.slice';
import { notificationReducer } from '../modules/notification.slice';
import { prioritiesModule } from '../modules/profile-management/priorities.slice';
import { profileManagementReducer } from '../modules/profile-management/profiles.slice';
import { fileUploadModule } from '../modules/registration-import/file-upload.slice';
import { importRequestsModule } from '../modules/registration-import/import-requests.slice';
import { importsModule } from '../modules/registration-import/imports.slice';
import { advisorSelectionModule } from '../modules/selections/advisor-selection.slice';
import { moduleSelectionReducer } from '../modules/selections/module-selection.slice';
import { profileSelectionReducer } from '../modules/selections/profile-selection.slice';
import { semesterSelectionReducer } from '../modules/selections/semester-selection.slice';
import { semesterManagementModule } from '../modules/semester-management/semester-management.slice';
import { studentManagementModule } from '../modules/student-management/student-management.slice';
import { studentSearchModule } from '../modules/student-management/student-search.slice';
import { studentTabsModule } from '../modules/student-management/student-tabs.slice';
import { uasManagementModule } from '../modules/uas-management/uas-management.slice';
import { userManagementModule } from '../modules/user-management/user-management.slice';
import { examRegistrationsModule } from '../modules/exam-registrations/exam-registrations.slice';

export const rootReducer = combineReducers({
  notification: notificationReducer,
  auth: authReducer,
  application: appReducer,
  userManagement: userManagementModule.reducer,
  moduleRegistration: prioritizationReducer,
  registrationImport: fileUploadModule.reducer,
  importRequests: importRequestsModule.reducer,
  semesterSelection: semesterSelectionReducer,
  moduleSelection: moduleSelectionReducer,
  moduleManagement: moduleManagementReducer,
  uasRegistration: uasRegistrationsModule.reducer,
  profileManagement: profileManagementReducer,
  priorityManagement: prioritiesModule.reducer,
  importsManagement: importsModule.reducer,
  semesterManagement: semesterManagementModule.reducer,
  studentManagement: studentManagementModule.reducer,
  profileSelection: profileSelectionReducer,
  advisorSelection: advisorSelectionModule.reducer,
  studentSearch: studentSearchModule.reducer,
  studentTabs: studentTabsModule.reducer,
  uasManagement: uasManagementModule.reducer,
  moduleRegistrationExport: registrationExportModule.reducer,
  summary: summaryModule.reducer,
  template: templateReducer,
  examRegistrations: examRegistrationsModule.reducer,
});
